const contentApiOn = false;
const contentSource = contentApiOn ? 'contentApi' : 'contentStack';
const contentPath = contentApiOn ? 'plusApi' : 'plus';

export const getRegisterPage = state => state.getIn([contentSource, contentPath]).registerPage;

export const getLinkAccountPage = state => state.getIn([contentSource, contentPath]).linkAccountPage;

export const getTermsPage = state => state.getIn([contentSource, contentPath]).termsPage;

export const getCookiePage = state => state.getIn([contentSource, contentPath]).cookiePage;

export const getResponsibleGamblingPage = state => state.getIn([contentSource, contentPath]).responsibleGamblingPage;

export const getSupportPage = state => state.getIn([contentSource, contentPath]).supportPage;

export const getWithdrawPage = state => state.getIn([contentSource, contentPath]).withdrawPage;
